import { rangeButtonFilterList } from '../range-button/range-button.constants';
import { CECountryRangeItemComponent } from './ce-range-item.component';
import { RangeItemComponent } from './range-item.component';
export const disableRangeItem = (ctx: RangeItemComponent |CECountryRangeItemComponent) => {
  /* retrieving the range-button key from constant file */
  const rangeBtnKey = rangeButtonFilterList[ctx.tabInfo().tabName][0].key.toString();
  if (ctx.filter().associations) {
    return !!(
      ctx.baseForm().controls.filters.get(rangeBtnKey)?.get('from')?.value ||
      ctx.baseForm().controls.filters.get(rangeBtnKey)?.get('to')?.value
    );
  } else {
    return !!(ctx.form().get(rangeBtnKey)?.get('from')?.value || ctx.form().get(rangeBtnKey)?.get('to')?.value);
  }
};
